import type { MediaContainer, MediaContainerDataItem } from '../@types/item';

export interface ParsedMedia {
  files: MediaContainerDataItem[];
  id: string;
  sortOrder: number;
  type: string;
}

export const parseMedia = ({ files, id, sortOrder, type }: MediaContainer): ParsedMedia => ({
  files: (files || []).slice(),
  id,
  sortOrder,
  type,
});
